<div class="form-grou__wrapper">
    <ng-content></ng-content>
    <i ngClass="{{iconClass}}" *ngIf="icon" (click)="onClear($event)"></i>
    <i class="icon-x" *ngIf="!icon && clear && hasValue"></i>
</div>
<ng-content select="app-error-message"></ng-content>
<!--<span class="form-group__required">*</span>-->
